import { ListLoaderWrapper } from "../../../../../features/data-types"
import { TableName } from "../../../../../tables"
import { CustomerList } from "./customerList"

export const CustomerListLoader = () => (
    <ListLoaderWrapper table={TableName.CUSTOMERS}>
        <CustomerList />
    </ListLoaderWrapper>
)
